import React, { memo, ReactNode, RefObject, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as XIcon } from 'assets/images/x.svg';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import { ReactComponent as Chevron } from 'assets/images/chevron-left.svg';
import { useGlobalContext } from 'contexts/global-context';
import ButtonLink from 'components/button-link';
import './styles.scss';

interface IHeader {
  innerRef?: RefObject<HTMLDivElement>;
  hideBackBtn?: boolean;
  hideLogo?: boolean;
  renderChildren?: () => ReactNode;
  onClick?: () => void;
}

const Header: React.FC<IHeader> = ({
  innerRef,
  hideBackBtn = false,
  hideLogo= false,
  renderChildren,
  onClick
}) => {
  const { t } = useTranslation();
  const { loading } = useGlobalContext();
  const [showCloseIcon, setShowCloseIcon] = useState<boolean>(false);

  useEffect(() => {
    if (!loading) {
      setShowCloseIcon(true);
    }
  }, [loading]);

  const scrollToTop = useCallback(() => {
      window.scroll({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="header p-side flex items-center justify-between" ref={innerRef}>
      <ButtonLink className="control flex items-center" onClick={onClick}>
        {hideBackBtn ? showCloseIcon && <XIcon /> : (
          <div className="flex items-center">
            <Chevron />
            <span className="back-text">{t('backButton')}</span>
          </div>
        )}
      </ButtonLink>
      {renderChildren && renderChildren()}
      {!hideLogo && (
        <ButtonLink className="logo flex items-center justify-end" onClick={scrollToTop}>
          <Logo />
          <span>{t('catalogue')}</span>
        </ButtonLink>
      )}
    </div>
  );
};

export default memo(Header);
